angular.module('core')
    .filter('arrayJoin', function () {
        return (input, separator) => {
            if(!(input instanceof Array)) {
                return
            }
            return input.filter(x => x).join(separator || ', ')
        };
    })
    .filter('arrayObjectJoin', function () {
        return (input, separator, property) => {
            if(!(input instanceof Array)) {
                return
            }
            input = input.map(x => x[property])
            return input.filter(x => x).join(separator || ', ')
        };
    })
